import { render } from "./GerenZhongxin.vue?vue&type=template&id=0ef8fd54&scoped=true"
import script from "./GerenZhongxin.vue?vue&type=script&lang=js"
export * from "./GerenZhongxin.vue?vue&type=script&lang=js"

import "./GerenZhongxin.vue?vue&type=style&index=0&id=0ef8fd54&scoped=true&lang=stylus"

import exportComponent from "D:\\GameProject\\h5yaoji\\H5-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef8fd54"]])

export default __exports__